import { useEffect, useState } from "react";

import ReminderList from "../../../../components/reminder-time/reminder-list";
import ApiProfileManagement from "../../../../api/profile-management";
import { FormFieldName } from "../../../../components/form/form";

/**
 * LF360-1940 — the reminders a task carries, and every plan gets from it.
 *
 * Until now they were set once per plan activity, so the same task in six plans
 * was six pieces of the same manual work. Set here, they reach every activity
 * that is still following the task, and leave alone the ones somebody has
 * changed at the plan level.
 *
 * The same list and the same picker the plan panel uses, so a reminder means the
 * same thing wherever it is set.
 *
 * A reminder before the assignment is offered here whatever the task is: a task
 * does not know which plans it will end up in, and asking an admin to guess
 * would be worse than dropping it where it cannot apply — which is what the
 * backend does on the way onto a weekly activity.
 */
const TaskReminders = ({ value, onChange, readOnly = false }) => {
  const [triggerFields, setTriggerFields] = useState([]);

  useEffect(() => {
    let cancelled = false;

    ApiProfileManagement.getProfiles({ inputType: ["message:time"] })
      .then(({ data }) => {
        if (cancelled) return;

        setTriggerFields(
          (data?.subjectProfileFields || []).map((field) => ({
            value: field.id,
            label: field.title,
          }))
        );
      })
      // An offset needs a time question to count from. Without the list the
      // picker withholds that half rather than offering one the backend refuses,
      // so a failed request costs the offsets and not the screen.
      .catch(() => {
        if (!cancelled) setTriggerFields([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="task-drawer__reminders">
      <FormFieldName text="Reminders" />
      <ReminderList
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        allowLeadTime
        triggerFields={triggerFields}
      />
    </div>
  );
};

export default TaskReminders;
